import { ApolloLink, Observable } from '@apollo/client';
export class AsyncSplitLink extends ApolloLink {
    predicateFn;
    leftLink;
    rightLink;
    constructor(options) {
        super();
        this.predicateFn = options.predicate;
        this.leftLink = options.left;
        this.rightLink = options.right;
    }
    request(operation) {
        return new Observable((observer) => {
            // Execute the predicate function on every invocation
            this.predicateFn(operation)
                .then((shouldUseLeft) => {
                // Choose the appropriate link
                const link = shouldUseLeft ? this.leftLink : this.rightLink;
                // Subscribe to the chosen link
                return link?.request(operation)?.subscribe(observer);
            })
                .catch((error) => {
                console.error('AsyncSplitLink: Predicate error, defaulting to right link:', error);
                // Default to right link on error
                return this.rightLink.request(operation)?.subscribe(observer);
            });
        });
    }
}
/**
 * Factory function to create an AsyncSplitLink
 */
export function createAsyncSplitLink(options) {
    return new AsyncSplitLink(options);
}
